import { RouteProps } from "react-router";
import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import * as actions from "src/bepaid/store/model/Fetch/actions";

import Component from "./View";

const mapStateToProps = (state: RootState) => ({
  hasToken: selectors.hasToken(state),
  list: selectors.getCustomerList(state),
  statistics: selectors.getCustomerStatistics(state),
  total: selectors.getTotalCustomers(state)
});

const mapDispatchToProps = {
  getCustomerList: actions.getCustomerList,
  getCustomerStatistics: actions.getCustomerStatistics,
  selectCustomers: actions.selectCustomers
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
